import { useAppSelector } from 'src/redux/store';
import { Roles } from 'src/utils/roles/roles';

const useValidarRol = () => {
    const rolActivo = useAppSelector((estadoApp) => estadoApp.usuario.rolActivo);
    const usuarioId = useAppSelector((estadoApp) => estadoApp.usuario.usuario?.usuarioId);

    const validarRolActivoEstaEntreLosRoles = (roles: Roles[]) => {
        if (rolActivo) {
            const rolActivoEstaEntreLosRoles = roles.find(rol => rol === rolActivo.id)
            if (rolActivoEstaEntreLosRoles) {
                return true
            }
        }
        return false
    }
    
    return {rolActivo, validarRolActivoEstaEntreLosRoles, usuarioId}
}

export default useValidarRol